<div
  class="w-full bg-white overflow-hidden rounded-none border-0 shadow-none md:rounded-[10px] md:border md:border-[rgba(0,0,0,0.06)] md:shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_0px_rgba(0,0,0,0.1)]">
  <!-- Header card -->
  <div
    class="bg-[#e2e9ff] px-4 py-5 md:px-8 md:py-6 flex flex-col items-start gap-1">
    <h2
      class="m-0 font-semibold text-xl leading-tight min-[400px]:text-2xl md:text-[28px] md:leading-[40px] text-[#0a0a0a]">
      {{ title() }}
    </h2>
    @if (subtitle()) {
      <div class="flex items-center gap-2">
        <img
          src="/assets/icons/schools/schuleinheit.svg"
          alt=""
          class="h-4 w-4"
          draggable="false" />
        <span class="text-base text-[#717182]">{{ subtitle() }}</span>
      </div>
    }
  </div>

  <!-- Mitarbeitende / Lernende / Standort -->
  <div class="px-4 md:px-8">
    <div
      class="w-full border-[rgba(0,0,0,0.08)] border-y border-solid py-4 md:py-5">
      <div
        class="flex flex-col gap-5 md:flex-row md:items-start md:justify-between md:gap-4">
        <div class="flex min-w-0 flex-1 items-center gap-3">
          <div
            class="bg-[#dbeafe] rounded-full size-10 shrink-0 flex items-center justify-center">
            <img
              src="/assets/onboarding/onboarding-staff.svg"
              alt="Mitarbeitende"
              class="h-6 w-6 block"
              draggable="false" />
          </div>
          <div class="flex min-w-0 flex-col">
            <span class="text-[13px] leading-[20px] text-[#717182]">
              Mitarbeitende
            </span>
            <span
              class="font-semibold text-[18px] leading-[27px] text-[#0a0a0a]">
              {{ summary().countEmployees ?? 0 }}
            </span>
          </div>
        </div>

        <div class="flex min-w-0 flex-1 items-center gap-3">
          <div
            class="bg-[#dbeafe] rounded-full size-10 shrink-0 flex items-center justify-center">
            <img
              src="/assets/onboarding/onboarding-learners.svg"
              alt="Lernende"
              class="h-6 w-6 block"
              draggable="false" />
          </div>
          <div class="flex min-w-0 flex-col">
            <span class="text-[13px] leading-[20px] text-[#717182]">
              Lernende
            </span>
            <span
              class="font-semibold text-[18px] leading-[27px] text-[#0a0a0a]">
              {{ summary().countStudents ?? 0 }}
            </span>
          </div>
        </div>

        <div class="flex min-w-0 flex-1 items-center gap-3">
          <div
            class="bg-[#dbeafe] rounded-full size-10 shrink-0 flex items-center justify-center">
            <img
              src="/assets/onboarding/onboarding-locations.svg"
              alt="Standort"
              class="h-6 w-6 block"
              draggable="false" />
          </div>
          <div class="flex min-w-0 flex-col">
            <span class="text-[13px] leading-[20px] text-[#717182]">
              Standort
            </span>
            <span
              class="min-w-0 break-words font-semibold text-[14px] leading-[21px] text-[#0a0a0a]">
              {{ town() }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Body sections -->
  <div class="px-4 pt-8 pb-8 flex flex-col gap-8 md:px-8 md:pt-12">
    <!-- Schule & Profil -->
    <div class="flex flex-col gap-3">
      <h3 class="font-semibold text-[16px] text-[#111827]">
        Schule &amp; Profil
      </h3>

      <div class="flex flex-col">
        <div class="flex py-[10px] border-b-[0.558px] border-b-[#f3f4f6]">
          <span class="w-[160px] shrink-0 text-[13px] text-[#9ca3af]">
            Schulart
          </span>
          <span
            class="min-w-0 flex-1 break-words font-medium text-[14px] text-[#111827]">
            {{ summary().schoolType }}
          </span>
        </div>
        <div class="flex py-[10px] border-b-[0.558px] border-b-[#f3f4f6]">
          <span class="w-[160px] shrink-0 text-[13px] text-[#9ca3af]">
            Kooperationsschule
          </span>
          @if (summary().institutionId) {
            <span class="flex-1 text-[14px] font-normal text-[#111827]">
              {{ institutionName() }}
            </span>
          } @else {
            <span class="flex-1 text-[14px] font-normal text-[#d1d5db]">
              Keine Angabe
            </span>
          }
        </div>
      </div>
    </div>

    <!-- Über uns -->
    <div class="flex flex-col gap-2">
      <h3 class="font-semibold text-[16px] text-[#111827]">Über uns</h3>
      <p
        class="whitespace-pre-wrap break-words text-[15px] leading-[26px] text-[#717182]"
        [textContent]="summary().about"></p>
    </div>

    <!-- Standort -->
    <div class="flex flex-col gap-3">
      <h3 class="font-semibold text-[16px] text-[#111827]">Standort</h3>

      <div class="flex flex-col">
        <div
          class="flex items-start py-[10px] border-b-[0.558px] border-b-[#f3f4f6]">
          <span class="w-[160px] shrink-0 text-[13px] text-[#9ca3af]">
            Adresse
          </span>
          <div class="flex min-w-0 flex-1 items-center gap-2">
            <img
              src="/assets/onboarding/onboarding-locations.svg"
              alt=""
              class="h-[16px] w-[16px]"
              draggable="false" />
            <span
              class="min-w-0 break-words font-medium text-[14px] text-[#111827]">
              {{ address() }}
            </span>
          </div>
        </div>

        <div class="flex items-start py-[10px]">
          <span class="w-[160px] shrink-0 text-[13px] text-[#9ca3af]">
            Webseite
          </span>
          <div class="flex min-w-0 flex-1 items-center gap-2">
            <img
              src="/assets/icons/schools/website_base.svg"
              alt=""
              class="h-[14px] w-[16px]"
              draggable="false" />
            @if (summary().website) {
              <a
                [href]="summary().website | websiteHref"
                target="_blank"
                class="font-medium text-[14px] text-light-primary break-all">
                {{ summary().website }}
              </a>
            } @else {
              <span class="font-normal text-[14px] text-[#d1d5db]">
                Keine Angabe
              </span>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Stufen & Zyklen -->
    <div class="flex flex-col gap-3">
      <h3 class="font-semibold text-[16px] text-[#111827]">
        Stufen &amp; Zyklen
      </h3>
      <div class="flex flex-wrap gap-2">
        @for (level of levels(); track level) {
          <div
            class="bg-[#e2e9ff] border-[0.558px] border-[#c7d9fe] rounded-full px-3 py-1 text-[13px] text-[#1e40af] font-normal leading-[19.5px]">
            {{ level }}
          </div>
        }
      </div>
    </div>

    <!-- Ansprechperson -->
    <div class="flex flex-col gap-3">
      <h3 class="font-semibold text-[16px] text-[#111827]">Ansprechperson</h3>

      <div class="flex min-w-0 flex-1 items-start gap-10">
        <div class="min-w-0 flex flex-1 flex-col">
          <p
            class="mb-0 break-words font-bold leading-[24px] text-[#1c1b1f] text-[16px]">
            {{ summary().contactName }}
          </p>
          @if (summary().contactPhone) {
            <p
              class="mb-0 break-words font-normal leading-[24px] text-[#1c1b1f] text-[16px]">
              {{ summary().contactPhone }}
            </p>
          }
          <p
            class="mb-0 break-all font-normal leading-[24px] text-light-primary text-[16px]">
            {{ summary().contactEmail }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
